export default __webpack_public_path__ + "static/media/sort_arrowDisabled.218dfb71.svg";